export function initializeOrder($item, resetLabel) {
	var $itemsOrder = $item.closest('.eccContainer').children('.items-order');
	$itemsOrder.css('z-index', $item.parents('.eccContainer').length + 1); // want deeper ones to be on top
	if ($itemsOrder.length) {
		const $children = $itemsOrder.children('li');
		const $items = $item.parent().children();
		$.each($items, (i, item) => {
			let setLabel = false;
			if (!$(item).data('initial')) {
				$(item).data('initial', i + 1);
				setLabel = true;
			} else if (resetLabel) {
				setLabel = true;
			}
			if (setLabel) {
				$($children[i])
					.find('.item-label')
					.html(_.padStart(i + 1, 2, '0'));
			}
		});
		orderMatchHeight($item.parent());

		$itemsOrder.fadeIn();
	}
}

export function updateOrder($item, highlightItem = true) {
	const $itemsOrder = $item.closest('.eccContainer').children('.items-order');
	if ($itemsOrder.length) {
		const $children = $itemsOrder.children('li');
		const $items = $item.parent().children();
		let reordered = false;
		$.each($items, (i, item) => {
			const index = i + 1;
			const initial = $(item).data('initial');
			$(item).data('current', index);
			const child = $children[i];
			$(child)
				.find('.item-label')
				.html(_.padStart(index, 2, '0'));
			const $content = $(child).find('.item-content');
			$content.removeClass('latest');
			if (index !== initial) {
				$content.html(`(was ${_.padStart(initial, 2, '0')})`);
				if (highlightItem && $item.index() + 1 === index) {
					$content.addClass('latest');
				}
				reordered = true;
			} else {
				$content.html('');
			}
		});
		if (!reordered) {
			$itemsOrder.removeClass('reordered');
			setTimeout(() => {
				if (!$itemsOrder.hasClass('reordered')) {
					$itemsOrder.fadeOut();
				}
			}, 5000);
		} else {
			$itemsOrder.addClass('reordered');
		}
		orderMatchHeight($item.parent());
	}
}

export function orderMatchHeight($collection) {
	const $items = $collection.children();
	var $itemsOrder = $collection.closest('.eccContainer').children('.items-order');
	let animate = $itemsOrder.is(':visible');
	if (animate) {
		setTimeout(() => {
			animate = false;
		}, 325);
	}
	if ($itemsOrder.length) {
		const $children = $itemsOrder.children('li');
		$.each($items, (i, item) => {
			const $child = $($children[i]);

			let height = $(item).height();
			$child.children('.item').css('height', height);
			function matchHeight() {
				height = $(item).height();
				if (Math.abs(height - $child.children('.item').height()) > 1) {
					//height reporting varies by 1 sometimes causing jankiness
					$child.children('.item').css('height', height);
				}
				if (animate) {
					requestAnimationFrame(matchHeight);
				}
			}
			if (animate) {
				setTimeout(() => {
					$child.children('.item').css('height', $(item).height());
				}, 350);
				requestAnimationFrame(matchHeight);
			}
			if (!$(item).hasClass('active')) {
				$(item).find('.items-order').fadeOut();
			} else {
				$(item).find('.items-order.reordered').fadeIn();
			}
		});
	}
}
